import React, { useEffect, useRef } from "react";
import "./table.css";

function ColumnVisibilityMenu({
  columns,
  visibleIds,
  onToggle,
  onToggleAll,
  onClose,
  selectAllLabel = "Select All",
}) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose?.();
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [onClose]);

  const hideable = columns.filter((c) => c.hideable !== false);
  const allVisible = hideable.length > 0 && hideable.every((c) => visibleIds.has(c.id));
  const someVisible = hideable.some((c) => visibleIds.has(c.id));
  const visibleHideableCount = hideable.filter((c) => visibleIds.has(c.id)).length;

  return (
    <div className="oh-col-menu" ref={ref} role="menu">
      <label className="oh-col-menu__row">
        <input
          type="checkbox"
          className="oh-col-menu__check oh-col-menu__check--all"
          checked={allVisible}
          ref={(el) => {
            if (el) el.indeterminate = someVisible && !allVisible;
          }}
          onChange={() => {
            if (!allVisible) onToggleAll?.(true);
          }}
        />
        <span className="oh-col-menu__label oh-col-menu__label--all">{selectAllLabel}</span>
      </label>
      {hideable.map((col) => {
        const isChecked = visibleIds.has(col.id);
        const isLastVisible = isChecked && visibleHideableCount <= 1;

        return (
        <label key={col.id} className={`oh-col-menu__row${isLastVisible ? " oh-col-menu__row--disabled" : ""}`}>
          <input
            type="checkbox"
            className="oh-col-menu__check"
            checked={isChecked}
            disabled={isLastVisible}
            onChange={() => {
              if (!isLastVisible) onToggle?.(col.id);
            }}
          />
          <span className="oh-col-menu__label">{col.header ?? col.label ?? col.id}</span>
        </label>
        );
      })}
    </div>
  );
}

export default ColumnVisibilityMenu;
